<template>
  <section class="the-map" :style="{'--position-desc': `${positionDesc}px` }"
           style="-webkit-transform:translate3d(0,0,0);">
    <div class="bg-black w-full blex relative mt-200 lg:mt-0 pb-200-vw" style="-webkit-transform:translate3d(0,0,0);">
      <div class="w-full  px-16 lg:px-200 pb-20">
        <div class="blex-left bg-black w-full">
          <div class="text-white font-bold text-2xl lg:text-6xl blex pt-100 lg:pt-210 bottom-gradient pb-12">
            MAP
          </div>
        </div>
        <div class="text-white font-medium leading-xs text-2xs lg:text-base py-30 w-full">
          {{ $t('map.1') }}<br class="hidden lg:block">
          {{ $t('map.2') }}
        </div>
        <div class="text-white font-medium leading-xs text-2xs lg:text-base w-full">
          {{ $t('map.3') }}<br class="hidden lg:block">
          {{ $t('map.4') }}<br class="hidden lg:block">
          {{ $t('map.5') }}

        </div>
      </div>

      <!-- map     -->
      <!--      <div class="w-full h-130-screen">-->
      <div class="w-full">
        <div class="map-wrapper">
          <div class="world-bg"
               :class="desc ? 'on' : null"
               @click="initMap"
          ></div>
          <!--   지도 세계관 이미지       -->
          <img @click="initMap" src="@/assets/images/pages/main/map/map3.png" class="map on hidden lg:block">
          <img @click="initMap" src="@/assets/images/pages/main/map/mMap3.png" class="map lg:hidden block">

          <!--   낚시 세계관 이미지       -->
          <div class="blex">
            <img ref="img1"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/map/fishing.png') : require('@/assets/images/pages/main/map/mFishing.png')"
                 class="fishing cursor-pointer"
                 :class="{'on': isActive[0]}"
                 @click="clickedImg(0)"
                 @mouseover="isFishing = true"
                 @mouseleave="isFishing = false"
            >
            <div class="fishing-title title cursor-pointer"
                 @click="clickedImg(0)"
                 @mouseover="isFishing = true"
                 @mouseleave="isFishing = false"
                 :class="!isActive[0] && isFishing ? 'on' : ''"
            >
              {{ $t('map.title.1') }}
            </div>
          </div>
          <div class="fising-spot spot"
               @mouseover="isFishing = true"
               @mouseleave="isFishing = false"
               @click="clickedImg(0)"
          >
          </div>
          <!--   농업 세계관 이미지       -->
          <div class="blex"
          >
            <img ref="img2"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/map/agriculture.png') : require('@/assets/images/pages/main/map/mAgriculture.png')"
                 class="agriculture cursor-pointer"
                 :class="{'on': isActive[1]}"
                 @click="clickedImg(1)"
                 @mouseover="isAgriculture = true"
                 @mouseleave="isAgriculture = false"
            >
            <div class="agriculture-title title cursor-pointer"
                 :class="!isActive[1] && isAgriculture ? 'on' : ''"
                 @mouseover="isAgriculture = true"
                 @mouseleave="isAgriculture = false"
                 @click="clickedImg(1)"
            >
              {{ $t('map.title.2') }}
            </div>
          </div>
          <div class="agriculture-spot spot"
               @click="clickedImg(1)"
               @mouseover="isAgriculture = true"
               @mouseleave="isAgriculture = false"
          ></div>
          <!--   농장 세계관 이미지       -->
          <div class="blex"
          >
            <img ref="img3"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/map/farm.png') : require('@/assets/images/pages/main/map/mFarm.png')"
                 class="farm cursor-pointer"
                 :class="{'on': isActive[2]}"
                 @click="clickedImg(2)"
                 @mouseover="isFarm = true"
                 @mouseleave="isFarm = false"
            >
            <div class="farm-title title cursor-pointer"
                 @mouseover="isFarm = true"
                 @click="clickedImg(2)"
                 @mouseleave="isFarm = false"
                 :class="!isActive[2] && isFarm ? 'on' : ''"
            >
              {{ $t('map.title.3') }}
            </div>
          </div>
          <div class="farm-spot spot"
               @mouseover="isFarm = true"
               @mouseleave="isFarm = false"
               @click="clickedImg(2)"
          ></div>
          <!--   체광 세계관 이미지       -->
          <div class="blex">
            <img ref="img4"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/map/mining.png') : require('@/assets/images/pages/main/map/mMining.png')"
                 class="mining cursor-pointer"
                 :class="{'on': isActive[3]}"
                 @click="clickedImg(3)"
                 @mouseover="isMining = true"
                 @mouseleave="isMining = false"
            >
            <div class="mining-title title cursor-pointer""
                 :class="!isActive[3] && isMining ? 'on' : ''"
                 @mouseover="isMining = true"
                 @mouseleave="isMining = false"
                 @click="clickedImg(3)"
            >
              {{ $t('map.title.4') }}
            </div>
          </div>
          <div class="mining-spot spot"
               @mouseover="isMining = true"
               @mouseleave="isMining = false"
               @click="clickedImg(3)"
          >

          </div>

          <!-- @todo : 각 세계관 호버 시, 모바일에서는 세계과 클릭 시      -->
          <transition name="fade-bottom">
            <description :value="desc" v-if="desc"/>
          </transition>
        </div>

      </div>

    </div>
  </section>

</template>

<script>
import Description from '@/views/components/theMap/Description'

export default {
  name: 'TheMap',
  components: {
    Description
  },
  data: () => ({
    isAgriculture: false,
    isFarm: false,
    isFishing: false,
    isMining: false,
    description: [
      {
        name: 'map.world.1',
        desc: 'map.detail.1'
      },
      {
        name: 'map.world.2',
        desc: 'map.detail.2'
      },
      {
        name: 'map.world.3',
        desc: 'map.detail.3'
      },
      {
        name: 'map.world.4',
        desc: 'map.detail.4'
      }
    ],
    isActive: [false, false, false, false],
    // tl: [null, null, null, null],
    positionDesc: 0,
    currentScroll: 0,
    imageCount: 0,
    loadedImageCount: 0
  }),
  computed: {
    desc() {
      const index = this.isActive.findIndex(x => x)
      if (index > -1) return this.description[index]
      else return null
    }
  },
  watch: {
    '$store.state.scrollY'(val) {
      if (Math.abs(val - this.currentScroll) > 500) {
        this.isActive = [false, false, false, false]
      }
    },
    loadedImageCount(val) {
      // if (this.imageCount === val && this.$scrollTrigger) {
      //   // console.log('fire the map')
      //   this.$scrollTrigger.refresh()
      // }
    }
  },
  methods: {
    mouseoverImg(val) {
      if (this.$store.state.windowWidth > 1024) {
        this.isActive = [false, false, false, false]
        this.$set(this.isActive, val, true)
      }
    },
    mouseLeaveImg() {
      this.isActive = [false, false, false, false]
    },
    initMap() {
      this.isActive = [false, false, false, false]
    },
    clickedImg(val) {
      /**
       * fishing
       * agriculture
       * farm
       * mining
       */
      let className = null
      switch (val) {
        case 0 :
          className = 'fishing'
          break
        case 1 :
          className = 'agriculture'
          break
        case 2 :
          className = 'farm'
          break
        case 3 :
          className = 'mining'
          break
      }
      // const ele = document.getElementsByClassName(className)[0]
      // this.positionDesc = ele.getBoundingClientRect().y + ele.getBoundingClientRect().height
      this.currentScroll = this.$store.state.scrollY

      // if (!this.isActive[val]) {
      //   if (window.locoScroll) {
      //     window.locoScroll.stop()
      //   }
      // } else {
      //   if (window.locoScroll) {
      //     window.locoScroll.start()
      //   }
      // }
      // this.tl[index].reverse(0.3)
      // this.tl[index] = null
      // this.isActive.forEach((active, index) => {
      //   if (val === index && !active) {
      //     this.tl[val] = this.$gsap.to(this.$refs[`img${val + 1}`], {
      //       right: '50%',
      //       top: '50%',
      //       x: '50%',
      //       y: '50%',
      //       scale: 1.5,
      //       zIndex: 2,
      //       duration: 0.3
      //     })
      //   } else if (val === index) {
      //     this.tl[index].reverse(0.3)
      //     this.tl[index] = null
      //   } else if (this.tl[index]) {
      //     this.tl[index].reverse(0.3)
      //     this.tl[index] = null
      //   }
      // })
      this.$set(this.isActive, val, !this.isActive[val])
    }
  },
  mounted() {
    const images = this.$el.querySelectorAll('img')
    this.imageCount = images.length
    images.forEach(img => {
      if (img.complete) {
        this.loadedImageCount++
      } else {
        img.addEventListener('load', () => this.loadedImageCount++)
      }
    })
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  .map-wrapper {
    width: 100%;
    position: relative;


    .frame {
      position: absolute;
      bottom: 10%;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 2;

      @media screen and (max-width: 1024px) {
        bottom: unset;
        //top: 0;
        top: var(--position-desc);
        transform: translate(-50%, 50%);
        //position: fixed;
        //bottom: unset;
        //top: ;
      }
    }

    .world-bg {
      display: none;

      &.on {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: rgba(0, 0, 0, .5);
        transition: background-color .2s linear, z-index .1s linear;
        cursor: pointer;
      }
    }

    //&::after {
    //  content: '';
    //  position: absolute;
    //  width: 100%;
    //  height: 100%;
    //  top: 0;
    //  left: 0;
    //  z-index: -1;
    //  background-color: rgba(0, 0, 0, 0);
    //  transition: background-color .2s linear, z-index .1s linear;
    //}

    //&.on {
    //  &::after {
    //    background-color: rgba(0, 0, 0, .5);
    //    z-index: 1;
    //  }
    //}

    .map {
      width: 100%;

      @media screen and (max-width: 1024px) {
      }
    }

    .spot {
      position: absolute;
      width: 24px;
      height: 24px;
      background-color: rgba(255, 255, 255, .5);
      border-radius: 50%;
      opacity: .5;
      animation: spot 2s linear infinite;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #fff;
      }

      @media screen and (max-width: 1024px) {

        width: 20px;
        height: 20px;
        &::after {
          width: 10px;
          height: 10px;
        }

      }
    }

    @keyframes spot {
      0% {
        opacity: 0;
        transform: scale(1);
      }
      50% {
        opacity: 1;
        transform: scale(1.2);
      }
      100% {
        opacity: 0;
        transform: scale(1.4);
      }
    }

    .fising-spot {
      right: 20%;
      top: 74%;
      @media screen and (max-width: 1024px) {
        right: 20%;
        top: 76%;
      }

    }

    .fishing {
      position: absolute;
      width: 40vw;
      right: 5%;
      top: 55%;
      transition: transform .3s ease-in-out;
      transform: translate(0, 0) scale(1);
      -webkit-transform: translate3d(0, 0, 0);
      @media screen and (max-width: 1024px) {
        top: 70%;
        width: 60vw;
        right: 2%;
      }


      &.on {
        right: 50%;
        top: 50%;
        transform: translate(50%, -50%) scale(1.5);
        //transform: scale(1.1);
        z-index: 2;
      }

    }

    .title {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-top: 1px solid;
      border-bottom: 1px solid;
      border-image: linear-gradient(to right, transparent, #ffffff, transparent);
      border-image-slice: 1;
      width: 9.813vw;
      height: 50px;
      color: #fff;
      font-size: 1.354vw;
      font-weight: 500;
      backdrop-filter: blur(4px);
      background: linear-gradient(270deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.38) 49.35%, rgba(0, 0, 0, 0.13) 100%);
      z-index: 1;

      @media screen and (max-width: 1024px) {
        min-width: 80px;
        width: auto;
        max-width: 120px;
        height: 25px;
        font-size: 14px;
      }

    }

    .fishing-title {
      display: none;
      //right: 5%;
      //top: 55%;
      right: 17%;
      top: 68%;

      &.on {
        display: flex;
      }
    }

    .mining-title {
      display: none;
      //left: 5%;
      //top: 50%;
      left: 13.5%;
      top: 58%;

      &.on {
        display: flex;
      }
    }

    .agriculture-title {
      display: none;
      //right: 16%;
      //top: 35%;

      right: 28.5%;
      top: 36%;

      &.on {
        display: flex;
      }

      @media screen and (max-width: 1024px) {
        right: 20.5%;
        top: 47%;
      }
    }

    .farm-title {
      display: none;
      //left: 13%;
      //top: 35%;
      left: 25.5%;
      top: 37%;

      &.on {
        display: flex;
      }

      @media screen and (max-width: 1024px) {
        left: 21.5%;
        top: 37%;
      }
    }

    .agriculture {
      position: absolute;
      width: 36vw;
      right: 13%;
      top: 33%;
      transition: transform .3s ease-in-out;
      transform: translate(0, 0) scale(1);
      -webkit-transform: translate3d(0, 0, 0);
      @media screen and (max-width: 1024px) {
        width: 62vw;
        right: 0;
        top: 49%;
      }

      &.on {
        right: 50%;
        top: 50%;
        transform: translate(50%, -50%) scale(1.5);
        z-index: 2;
      }

    }

    .agriculture-spot {
      right: 32%;
      top: 43%;
      @media screen and (max-width: 1024px) {
        right: 29%;
        top: 53%;
      }
    }

    .farm {
      position: absolute;
      width: 36vw;
      left: 13%;
      top: 35%;
      transition: transform .3s ease-in-out;
      transform: translate(0, 0) scale(1);
      -webkit-transform: translate3d(0, 0, 0);
      @media screen and (max-width: 1024px) {
        width: 60vw;
        left: 0;
        top: 40%;
      }

      &.on {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1.5);
        z-index: 2;
      }

    }

    .farm-spot {
      left: 29%;
      top: 43%;
    }

    .mining {
      position: absolute;
      width: 33vw;
      left: 5%;
      top: 50%;
      transition: transform .3s ease-in-out;
      transform: translate(0, 0) scale(1);
      -webkit-transform: translate3d(0, 0, 0);

      @media screen and (max-width: 1024px) {
        width: 52vw;
        left: 2%;
        top: 59%;
      }

      &.on {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1.5);
        z-index: 2;
      }

    }

    .mining-spot {
      left: 17%;
      top: 65%;
      @media screen and (max-width: 1024px) {
        left: 20%;
        top: 65%;
      }
    }


  }


}

</style>
